import { Injectable, Pipe, PipeTransform } from '@angular/core';
/*
  See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
  Angular 2 Pipes.
*/
@Pipe({
  name: 'fontediferencafilter'
})
@Injectable()
export class FonteDiferencaFilter implements PipeTransform {
  transform(item: any, args: any[]): any {
    if (args != []) {
      return args.filter((arg) => arg.id == item).map((objetoFiltrado) => {
        return objetoFiltrado.dsFonteDiferenca;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/tipo-fonte-diferenca-filter.ts